import React, { useState } from 'react';
import { Box, Button, IconButton, Typography, Switch, Chip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import AddFikraFeature from '../../../Modals/addFikraFeature';

const featureData = [
    {
        id: 1,
        title: 'Executive Summary',
        description: 'executive_summary | summary',
        tiers: { free: true, premium: true, enterprise: true },
        outputs: { web: true, pdf: true, excel: false },
        status: true,
    },
    {
        id: 2,
        title: 'Market Opportunity',
        description: 'market_opportunity | content',
        tiers: { free: true, premium: true, enterprise: true },
        outputs: { web: true, pdf: true, excel: false },
        status: true,
    },
    {
        id: 3,
        title: 'Market Analysis',
        description: 'market_analysis | content',
        tiers: { free: true, premium: true, enterprise: true },
        outputs: { web: true, pdf: true, excel: false },
        status: true,
    },
    {
        id: 4,
        title: 'Competitor Landscape',
        description: 'competitor_landscape | table',
        tiers: { free: true, premium: true, enterprise: true },
        outputs: { web: true, pdf: true, excel: false },
        status: true,
    },
    {
        id: 5,
        title: 'Financial Projections',
        description: 'financial_projections | financials',
        tiers: { free: true, premium: true, enterprise: true },
        outputs: { web: true, pdf: true, excel: false },
        status: true,
    },
    {
        id: 6,
        title: 'Financial Forecast',
        description: 'financial_forecast | financials',
        tiers: { free: false, premium: true, enterprise: true },
        outputs: { web: true, pdf: true, excel: true },
        status: true,
    },
];

const FikraLabFeatures = () => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <div className="fikra_features_wrapper">
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1>Fikra Lab Features</h1>
                    <p>Configure report sections, order, and tier availability.</p>
                </div>
                <div className="right_s">
                    <Button
                        className="btn btn_primary"
                        onClick={() => setOpenModal(true)}
                        startIcon={<AddIcon />}
                    >
                        Add Feature
                    </Button>
                </div>
            </div>

            <div className="feature_list_container">
                {featureData.map((feature, index) => (
                    <div className="feature_card_row" key={feature.id}>
                        <div className="index_num">{index + 1}</div>

                        <div className="feature_info">
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>

                        <div className="feature_settings">

                            <div className="status_toggle">
                                <Switch
                                    checked={feature.status}
                                    color="success"
                                    size="small"
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <AddFikraFeature
                open={openModal}
                handleClose={() => setOpenModal(false)}
            />
        </div>
    );
};

export default FikraLabFeatures;
